export default __webpack_public_path__ + "5fd7ee514dbabba40b8e77b3963e6068.png";